module.exports = __webpack_public_path__ + "static/img/wealth_level_57.986d52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_57.png
// module id = Ms3O
// module chunks = 0